import React, { useState, useEffect, useLayoutEffect } from "react";
import Picker from "react-simple-picker";
import "./SizeSelector.css";

const SizeSelector = ({ label, onSizeChange }) => {
  const [selectedMillimeter, setSelectedMillimeter] = useState(0);
  const [selectedCentimeter, setSelectedCentimeter] = useState(0);
  const [pickerHeight, setPickerHeight] = useState(
    window.innerWidth > 768 ? 250 : 120
  );

  useLayoutEffect(() => {
    setPickerHeight(window.innerWidth > 768 ? 250 : 120);
  }, []);

  const millimeters = Array.from({ length: 100 }, (_, index) => index); 
  const centimeters = Array.from({ length: 201 }, (_, index) => index); 

  const handleMillimeterChange = (index) => {
    setSelectedMillimeter(index);
  };

  const handleCentimeterChange = (index) => {
    setSelectedCentimeter(index);
  };

  useEffect(() => {
    onSizeChange(label, selectedCentimeter, selectedMillimeter);
  }, [selectedCentimeter, selectedMillimeter]);

  const customStyle = {
    background: "transparent",
    fontSize: "20px",
    color: "green",
  };

  return (
    <div className="sizeSelectorWrapper centeredFlex">
      <div className="sizeSelectorField">
        <Picker
          height={pickerHeight}
          initCount={0}
          preloadCount={50}
          iconAdd={null}
          iconMinus={null}
          optionGroups={{ mm: millimeters }}
          valueGroups={{ mm: selectedMillimeter }}
          maxCount={99}
          onChange={(valueIndex) => handleMillimeterChange(valueIndex)}
          renderMask={(Mask) => (
            <Mask
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "0 1rem 1rem 0",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderLeft: "none",
                paddingRight: "15px",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>mm</span>
            </Mask>
          )}
          style={customStyle}
        />
      </div>
      <div className="sizeSelectorField">
        <Picker
          height={pickerHeight}
          initCount={0}
          preloadCount={50}
          iconAdd={null}
          iconMinus={null}
          optionGroups={{ cm: centimeters }}
          valueGroups={{ cm: selectedCentimeter }}
          maxCount={200}
          onChange={(valueIndex) => handleCentimeterChange(valueIndex)}
          renderMask={(Mask) => (
            <Mask
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "1rem 0 0 1rem",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRight: "none",
                paddingRight: "15px",
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>cm</span>
            </Mask>
          )}
          style={customStyle}
        />
      </div>
    </div>
  );
};

export default SizeSelector;
